'use client';
// Forward-only cursors mean the URL only carries `?cursor=<current>` — there
// is no `prevCursor` server-side. To support a "Newer" button on PagedTable
// we keep a client-side breadcrumb stack of cursors visited, persisted to
// sessionStorage so a refresh doesn't lose it.
import { useCallback, useEffect, useState } from 'react';
const STORAGE_PREFIX = 'paged-table-history:';
function readStack(key) {
    if (typeof window === 'undefined')
        return [];
    try {
        const raw = window.sessionStorage.getItem(STORAGE_PREFIX + key);
        if (!raw)
            return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed))
            return [];
        return parsed.filter((x) => x === null || typeof x === 'string');
    }
    catch {
        return [];
    }
}
function writeStack(key, stack) {
    if (typeof window === 'undefined')
        return;
    try {
        window.sessionStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(stack));
    }
    catch {
        // sessionStorage quota or disabled — silently degrade
    }
}
export function useCursorHistory(storageKey) {
    const [stack, setStack] = useState(() => readStack(storageKey));
    useEffect(() => {
        writeStack(storageKey, stack);
    }, [stack, storageKey]);
    const push = useCallback((cursor) => {
        setStack((s) => [...s, cursor]);
    }, []);
    const pop = useCallback(() => {
        let popped = null;
        setStack((s) => {
            if (s.length === 0)
                return s;
            popped = s[s.length - 1] ?? null;
            return s.slice(0, -1);
        });
        return popped;
    }, []);
    const reset = useCallback(() => {
        setStack([]);
    }, []);
    return { canGoBack: stack.length > 0, push, pop, reset };
}
//# sourceMappingURL=useCursorHistory.js.map